import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavbarVisibilityService } from './shared/services/navbar-visibility.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { LoadingService, LoadingState } from './shared/services/loading.service';
import { ToastService } from './shared/services/toast.service';

@Component({
  selector: 'app-root',
  template: `
    <div class="global-loading-bar" [class.active]="loadingState.active" aria-hidden="true">
      <div class="global-loading-bar__track"></div>
    </div>

    @if (loadingState.active && (loadingState.action === 'saving' || loadingState.action === 'deleting')) {
    <div class="global-loading-chip" [attr.data-action]="loadingState.action" role="status" aria-live="polite">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span>{{ loadingState.message }}</span>
    </div>
    }

    <app-navbar *ngIf="isNavbarVisible"></app-navbar>
    <router-outlet></router-outlet>
    <app-custom-toast></app-custom-toast>
  `,
  styles: [`
    .global-loading-bar {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 20000;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.15s ease;
    }
    .global-loading-bar.active {
      opacity: 1;
    }
    .global-loading-bar__track {
      height: 100%;
      width: 40%;
      background: linear-gradient(90deg, #0d6efd, #6ea8fe, #0d6efd);
      background-size: 200% 100%;
      animation: global-loading-slide 1.1s ease-in-out infinite;
      border-radius: 0 2px 2px 0;
    }
    @keyframes global-loading-slide {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(350%); }
    }

    .global-loading-chip {
      position: fixed;
      top: 14px;
      right: 16px;
      z-index: 20001;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 14px;
      border-radius: 999px;
      background: rgba(33, 37, 41, 0.92);
      color: #fff;
      font-size: 13px;
      font-weight: 500;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
      pointer-events: none;
    }
    .global-loading-chip[data-action="saving"] {
      background: rgba(13, 110, 253, 0.95);
    }
    .global-loading-chip[data-action="deleting"] {
      background: rgba(220, 53, 69, 0.95);
    }
    .global-loading-chip .spinner-border {
      width: 0.95rem;
      height: 0.95rem;
      border-width: 0.15em;
    }
  `]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'tristate-ng';
  isNavbarVisible = false;
  loadingState: LoadingState = {
    active: false,
    pending: 0,
    action: 'idle',
    message: '',
  };

  private subs = new Subscription();

  constructor(
    private _navbarVisibilityService: NavbarVisibilityService,
    private _router: Router,
    private _title: Title,
    private _loading: LoadingService,
    private _toast: ToastService,
  ) { }

  ngOnInit(): void {
    this._toast.toastId = 'globalToast';
    this.HideNavbarOnLoginAndNotFound();
    this._title.setTitle(`${this.IsDevelopmentEnv() ? 'DEV::' : ''} TRISTATE`);

    this.subs.add(
      this._loading.state$.subscribe((state) => {
        this.loadingState = state;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  HideNavbarOnLoginAndNotFound() {
    this.subs.add(
      this._router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          this.isNavbarVisible =  !this._router.url.includes('/login') &&
                                  !this._router.url.includes('/not-found') &&
                                  !this._router.url.includes('/orders/print-ticket') &&
                                  !this._router.url.includes('/orders/print-invoice');
        }),
    );

    this.subs.add(
      this._navbarVisibilityService.isVisible$.subscribe(isVisible => {
        this.isNavbarVisible = isVisible;
      }),
    );
  }

  IsDevelopmentEnv(): boolean {
    return window.location.href.includes('localhost');
  }

}
